module.exports = __webpack_public_path__ + "static/media/teamAdmin_shirley.c4af52dc.svg";